var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tribe-box-category" }, [
    _c(
      "div",
      {
        staticClass: "ar mb-16",
        style: { "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%" }
      },
      [
        _c("img", {
          attrs: {
            src: _vm.category.acf.meta.image.sizes.medium_large,
            alt: _vm.category.name
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("p", {
      staticClass: "title mb-8",
      domProps: { innerHTML: _vm._s(_vm.category.name) }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-dark font-weight-light small mb-24",
      domProps: { innerHTML: _vm._s(_vm.category.acf.meta.content) }
    }),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn btn-accent",
        attrs: { href: _vm.route("nl.tribebox", _vm.category.slug) }
      },
      [
        _vm._v("Kies jouw Tribe Box "),
        _c("span", {
          staticClass: "arrow-right",
          domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }